import { useEffect, useState } from "react";
import ProductListPc from "./product_list_pc";
import ProductListMobile from "./product_list_mobile";
import { couponMessageResend, paymentHistory } from "../../../api/payment";
import { useNavigate } from "react-router-dom";
import { SessionStorageUtil } from "../../../utils/sessionStorageUtil";

function ProductList() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const pageSize = 10;

  const fetchList = async (page = 1) => {
    if (isFetching) return;
    setIsFetching(true);

    try {
      const res = await paymentHistory(page, pageSize);

      if (Object.keys(res).length === 0) {
        SessionStorageUtil.clearAll();
        navigate("/product_step1", { replace: true });
      }

      if (res.success === true) {
        const newData = res.data.transactions;

        setTotalCount(res.data.pagination.total_count);
        setCurrentPage(page);

        if (isMobile) {
          if (page === 1) {
            setData(newData);
          } else {
            setData((prev) => [...prev, ...newData]);
          }
        } else {
          setData(newData);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchList(1);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePageChange = (page) => {
    fetchList(page);
  };

  const resend = async (coupon_id) => {
    const res = await couponMessageResend(coupon_id);

    if (res.success === true) {
      alert("쿠폰이 재발송 되었습니다.");
    }
  };

  const commonProps = {
    data,
    totalCount,
    currentPage,
    pageSize,
    onPageChange: handlePageChange,
    resend,
  };

  return isMobile ? (
    <ProductListMobile {...commonProps} />
  ) : (
    <ProductListPc {...commonProps} />
  );
}

export default ProductList;
